import React, {} from 'react';

import { useNavigate, } from "react-router-dom";

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setItemsOffset } from 'redux/actions/inventoryActions';

// language
import { injectIntl, IntlShape } from 'react-intl';

// components
import QueryTableDevices from 'components-lib/QueryTable/QueryTableDevices';

// Material UI
import { Grid } from '@mui/material';

// icons
import { 
  containerIcon,
  kayakIcon,
  paddleIcon,
  vestIcon,
  helmetIcon,
  bagIcon,
} from 'assets/icons';

// types
import { ColumnWidths } from 'types/types';
import { WarehousesData } from 'types/typesRedux';

type Props = {
  intl: IntlShape;
}

const WarehousesTable = ( {intl}: Props ) => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  
  // data from redux
  const data = useSelector( (state: WarehousesData ) => state.warehouses )

  // If click on detail button set offset 0 and go to page detail container
  const handleDetailItem = ( id: number ) => {
    dispatch(setItemsOffset( 0 ));
    navigate( (`/admin/containers/container-detail/${id}`), { state: {
      id: id,
      }} 
    );
  }

  const getColumnMinWidth = (columnId: string, locale: string): string => {
    const minWidths: ColumnWidths = {
      doorStatusA: { default: "10%", hu: "12%" },
      doorStatusB: { default: "10%", hu: "12%" },
    };
  
    const columnConfig = minWidths[columnId];
    if (columnConfig) {
      return columnConfig[locale] || columnConfig.default;
    } else {
      return "auto";
    }
  };

  return (
    <Grid >
      <Grid 
        sx={{ maxWidth: "70rem", }}
      >
        <QueryTableDevices
          title= {intl.formatMessage( {id: 'tableContainers.warehouses.title'} )}
          tableData={ data.warehouses }
          pagePagination={false}
          totalCount={ 2 }
          columns= {[
              // { Header: intl.formatMessage( {id: 'tableUsers.id'} ), 
              // accessor: "id", 
              // width: "auto",
              // minWidth: "3%",
              // input: 'title',
              // },
              { Header: intl.formatMessage( {id: 'tableContainers.name'} ), 
                accessor: "name", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                },
              { Header: intl.formatMessage( {id: 'tableContainers.boatsCount'} ), 
                accessor: "kayakCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                titleIcon:kayakIcon,
              },
              { Header: intl.formatMessage( {id: 'tableContainers.paddleCount'} ), 
                accessor: "paddleCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                titleIcon:paddleIcon,
              },
              { Header: intl.formatMessage( {id: 'tableContainers.vestCount'} ), 
                accessor: "vestCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                titleIcon:vestIcon,
              },
              { Header: intl.formatMessage( {id: 'tableContainers.helmetCount'} ), 
                accessor: "helmetCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                titleIcon:helmetIcon,
              },
              { Header: intl.formatMessage( {id: 'tableContainers.bagCount'} ), 
                accessor: "bagCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
                titleIcon:bagIcon,
              },
              { Header: intl.formatMessage( {id: 'tableContainers.equipmentCount'} ), 
                accessor: "equipmentCount", 
                width: "auto",
                minWidth: "10%",
                input: 'title',
              },
          ]}
          button={ [{
            add: null,
            detail: true,
            edit: false,
            delete: false,
            block: false,
          }] }
          icon={containerIcon}
          onOffset={ null }
          onLimit={ null }
          onAddItem={ null }
          onDetailItem={ handleDetailItem }
          onEditBtn={ null }
          onBlockItem={ null }
          onRemoveBtn={ null }
          />

      </Grid>
    </Grid>
  );
};

export default injectIntl(WarehousesTable);